/* template */
<template><div class="flights-type"><mpx-view v-for="(item, index) in (tabs)" :key="item['item.key']" :class="(item.key === actived ? 'active' : '')" @tap="onTabTap(item)" class="flights-type-item"><span class="text">{{item.text}}</span></mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m0555aa08"}'>
  .flights-type
    height 46px
    padding-top 6px
    @extend .flex-center
    justify-content space-between
    &-item
      flex 1
      text-align center
      color #666
      font-size 14px
      line-height 50px
      position relative
      .text
        position relative
        z-index 1
      &.active
        color #222
        font-weight 600
        &::after
          content ''
          position absolute
          display block
          width 28px
          height 4px
          left 50%
          bottom 16px
          transform translateX(-50%)
          background-color #FF6400
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0555aa08"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./child-tab.mpx.js?isComponent&outputPath=components%2Fchild-tab0555aa08%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./child-tab.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fchild-tab0555aa08%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0555aa08"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/child-tab0555aa08/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
